"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ACSChatMessageType;
(function (ACSChatMessageType) {
    ACSChatMessageType["Text"] = "text";
    ACSChatMessageType["TopicUpdated"] = "topicUpdated";
    ACSChatMessageType["ParticipantAdded"] = "participantAdded";
    ACSChatMessageType["ParticipantRemoved"] = "participantRemoved";
})(ACSChatMessageType || (ACSChatMessageType = {}));
exports.default = ACSChatMessageType;
//# sourceMappingURL=ACSChatMessageType.js.map